import React, { useRef, useState } from "react";
import * as THREE from "three";
import { Canvas, useFrame, useThree } from "@react-three/fiber";
import { useSpring, animated } from "@react-spring/three";
import {
  OrbitControls,
  Stars,
  Plane,
  MeshDistortMaterial,
} from "@react-three/drei";

import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { useEffect } from "react/cjs/react.production.min";
import { Camera } from "three";
import { PlaneBufferGeometry } from "three";

function Box(props) {
  // This reference gives us direct access to the THREE.Mesh object
  const ref = useRef();
  // Hold state for hovered and clicked events
  const [hovered, hover] = useState(false);
  const [clicked, click] = useState(false);
  // Subscribe this component to the render-loop, rotate the mesh every frame
  useFrame((state, delta) => (ref.current.rotation.x += 0.01));
  // Return the view, these are regular Threejs elements expressed in JSX
  return (
    <mesh
      {...props}
      ref={ref}
      scale={clicked ? 1.5 : 1}
      onClick={(event) => click(!clicked)}
      onPointerOver={(event) => hover(true)}
      onPointerOut={(event) => hover(false)}
    >
      <boxGeometry args={[1, 1, 1]} />
      <meshStandardMaterial color={hovered ? "hotpink" : "orange"} />
    </mesh>
  );
}

function AddSphere({ position = [0, 0, 0], color = "#ffffff" }) {
  console.log(color);
  const ref = useRef();
  var opacity = 1;
  //動畫
  useFrame((state, delta) => {
    //ref.current.rotation.x += 0.01
    ref.current.position.z += delta * 500;

    if (ref.current.position.z > 1000) {
      ref.current.position.z = -1000;
    }
    //console.log(ref.current);
  });

  //邏輯....https://codepen.io/GraemeFulton/pen/BNyQMM

  //返回物件instance
  return (
    <mesh ref={ref} position={[position[0], position[1], position[2]]}>
      <boxGeometry args={[5, 5, 250]} />
      <MeshDistortMaterial
        attach="material"
        color={color}
        transparent
        opacity={0.5}
        distort={1.5}
        speed={1}
        roughness={1}
      />
    </mesh>
  );
}

export default function Test1() {
  //const gltf = useLoader(GLTFLoader , '/Poimandres.gltf');

  //const springs = useSpring({ scale: active ? 1.5 : 1 });
  const toP = useSpring({ rotation: [0, 180, 180] });

  return (
    <div style={{ height: "100vh", width: "100vw", backgroundColor: "#2e2e2e" ,zIndex:"-22"}}>
      <Canvas camera={{ rotation: toP.rotation }}>
        {
        <OrbitControls
          enablePan={true}
          enableZoom={false}
          enableRotate={false}
          makeDefault={true}
        />}
        {/* 黑天空背景 */}
        <Stars />
        <ambientLight intensity={0.5} />

        {/* 首頁面板 
        <animated.mesh>
          <planeGeometry attach="geometry" args={[10,5]} rotation={toP.rotation}/>
          <meshPhongMaterial
            attach="material"
            color="#f3f3f3"
            transparent
            opacity={0.8}
            side={THREE.DoubleSide}
          />
        </animated.mesh>*/}

        {/*  
        <Plane args={[10, 5]} position={[2.5, 0, 0]}>
          <meshPhongMaterial
            attach="material"
            color="#f3f3f3"
            transparent
            opacity={0.8}
            side={THREE.DoubleSide}
          />
        </Plane>*/}

        {Array(100)
          .fill(1)
          .map((el, i) => {
            var pos = [
              Math.random() * window.innerWidth - window.innerWidth / 2,
              Math.random() * window.innerHeight - window.innerHeight / 2,
              -i * 100,
            ];
            var randomColor = Math.floor(Math.random() * 16777215).toString(16);

            console.log(i);
            return <AddSphere position={pos} color={"#" + randomColor} />;
          })}
      </Canvas>
    </div>
  );
}
